/**
 * Clipboard helpers
 */

export interface RichText {
  html: string;
  text: string;
}

/**
 * Copy HTML with a plain-text alternative, so the paste target picks the
 * richest format it supports. Browsers without ClipboardItem (or a
 * rich-write API) get the plain text only.
 */
export async function copyRichText({ html, text }: RichText): Promise<void> {
  const canWriteRich =
    typeof ClipboardItem !== 'undefined' && typeof navigator.clipboard?.write === 'function';
  if (!canWriteRich) {
    await navigator.clipboard.writeText(text);
    return;
  }

  await navigator.clipboard.write([
    new ClipboardItem({
      'text/html': new Blob([html], { type: 'text/html' }),
      'text/plain': new Blob([text], { type: 'text/plain' }),
    }),
  ]);
}
